// extracted by mini-css-extract-plugin
export default {"GateBody":"rescue_GateBody__mrH7W","WidgetDisabled":"rescue_WidgetDisabled__L5UsP"};